<template>
	<div class="box">
		<v-container>
			<v-row no-gutters>
				<v-col>
					<h1>Verfahren zur Arbeitsverdichtung</h1>
					<p>Auf dieser Seite k&ouml;nnen Sie sich &uuml;ber Verfahren zur Arbeitsverdichtung informieren. Sie k&ouml;nnte die Liste der Verfahren durch Filter eingrenzen und erhalten zu jedem Verfahren weitergehende Informationen.</p>	
					<div style="display:none;">
						<p>FilterStatus: {{filterStatus}}</p>
						<p>FilterBox: {{filterBox}}</p>
						<p>FilterFacette: {{filterFacette}}</p>
						<p>Verfahrensuchfelder: {{verfahrenSuchfelder.length}}</p>
						<p>Freitextsuche: {{freitextsuche}}</p>
						<p>Lesezeichenliste: {{lesezeichenListe}} // {{lesezeichenAnzeigen}}</p>
						<p>Query: {{query}}</p>
						<p>sortierungKriterium: {{sortierungKriterium}}</p>
						<p>sortierungReihenfolge: {{sortierungReihenfolge}}</p>
					</div>				
				</v-col>
			</v-row>
			<v-row no-gutters v-if="teilnehmer != ''">
				<v-col cols="6">
					<h2>Lesezeichen</h2>
					<p>Sie k&ouml;nnen sich nur die Verfahren anzeigen lassen, f&uuml;r die Sie sich ein Lesezeichen gesetzt haben.</p>
				</v-col>
				<v-col align-self="end" style="margin-left:5em;">
					<v-checkbox 
						v-if="teilnehmer!=''"
						v-model="lesezeichenAnzeigen"
						color="red"
						off-icon="mdi-bookmark-outline"
						on-icon="mdi-bookmark"
						@click="verfahrenLesezeichen()"
						label="Eigene Lesezeichen anzeigen"
						true-value="1"
						false-value="0"
					>
					</v-checkbox>
				</v-col>
			</v-row>
		</v-container>
		<v-container v-if="lesezeichenAnzeigen == 0">
			<v-row no-gutters>
				<v-col>
					<h2>Suche nach Verfahren</h2>
					<p>Hier k&ouml;nnen Sie Kriterien festlegen, nach denen die Verfahren durchsucht werden. Zu Beginn sind alle Kriterien ausgew&auml;hlt und Sie haben die M&ouml;glichkeit, die Suche durch L&ouml;schen einzelner Kriterien inhaltlich einzuschr&auml;nken. Wenn bei einem Kriterium keine Auswahl getroffen wurde, dann wird dieses Kriterium bei der Auswahl der Verfahren nicht ber&uuml;cksichtigt.</p>
				</v-col>
			</v-row>
			<v-row no-gutters style="display:none;">
				<v-col align-self="center" class="spalte1">Status</v-col>
				<v-col align-self="center" class="spalte2">
					<v-dialog v-model="statusDialog" persistent max-width="800">
						<template v-slot:activator="{ on, attrs }">
							<v-icon color="primary" v-bind="attrs" v-on="on">mdi-information</v-icon>
						</template>
						<v-card>
							<v-card-title class="headline">Status</v-card-title>
							<v-card-text>
								<p>Sie k&ouml;nnen hier den Status des Verfahrens ausw&auml;hlen.</p>
								<ul>
									<li>Status 1: Verfahren eingereicht.</li>
									<li>Status 2: Verfahren aufgenommen.</li>
									<li>Status 3: Verfahren abgelehnt.</li>
								</ul>
							</v-card-text>
							<v-card-actions>
							<v-spacer></v-spacer>
								<v-btn color="primary" text @click="statusDialog=false">Schließen</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
				</v-col>
				<v-col align-self="center">
					<v-autocomplete chips deletable-chips multiple :items="statusKriterien" v-model="filterStatus"></v-autocomplete>
				</v-col>
			</v-row>
			<v-row no-gutters>
				<v-col align-self="center" class="spalte1">Verfahrensart</v-col>
				<v-col align-self="center" class="spalte2">
					<v-dialog v-model="boxenDialog" persistent max-width="800">
						<template v-slot:activator="{ on, attrs }">
							<v-icon color="primary" v-bind="attrs" v-on="on">mdi-information</v-icon>
						</template>
						<v-card>
							<v-card-title class="headline">Verfahren</v-card-title>
							<v-card-text>
								<p>Sie k&ouml;nnen hier die Art des Verfahrens ausw&auml;hlen. Bei den Verfahren handelt es sich um die foglenden zwei Arten:</p>
								<ul>
									<li>Einsch&auml;tzung: Verfahren zur Einsch&auml;tzung des Ausma&szlig;es der Arbeitsdichte.</li>
									<li>Intervention: Verfahren zur F&ouml;rderung des Umgangs mit Arbeitsdichte.</li>
								</ul>
							</v-card-text>
							<v-card-actions>
							<v-spacer></v-spacer>
								<v-btn color="primary" text @click="boxenDialog=false">Schließen</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
				</v-col>
				<v-col align-self="center">
					<v-autocomplete chips deletable-chips multiple :items="boxKriterien" v-model="filterBox">
						<template v-slot:selection="{ item }">
							<v-chip 
								:color="item.color" 
								close
								@click:close="removeBoxkriterium(item.value)"
							>{{ item.text }}
							</v-chip>
						</template>
					</v-autocomplete>
				</v-col>
			</v-row>
			<v-row no-gutters>
				<v-col align-self="center" class="spalte1">Facetten</v-col>
				<v-col align-self="center" class="spalte2">
					<v-dialog v-model="facettenDialog" persistent max-width="800">
						<template v-slot:activator="{ on, attrs }">
							<v-icon color="primary" v-bind="attrs" v-on="on">mdi-information</v-icon>
						</template>
						<v-card>
							<v-card-title class="headline">Facetten der Arbeitsdichte</v-card-title>
							<v-card-text>
								<p>Sie k&ouml;nnen die Suche nach spezifischen Facetten der Arbeitsdichte eingrenzen. Die folgende Liste charakterisiert die Facetten der Arbeitsdichte in knapper Form.</p>
								<ul>
									<li>Menge: Menge der Aufgaben, die in einem gewissen Zeitraum anfallen.</li>
									<li>Unterbrechungen: Ausma&szlig; der Unterbrechungen bei der Bearbeitung von Aufgaben.</li>
									<li>Gleichzeitigkeit: Ausma&szlig; der parallel zu erledigenden Aufgaben.</li>
									<li>Interdependenz: Ausma&szlig; der Vernetzung der Besch&auml;ftigten zur Aufgabenerf&uuml;llung.</li>
									<li>Arbeitsspitzen: Zeitweilige H&auml;ufung von Aufgaben.</li>
									<li>Erweiterte Erreichbarkeit: Erreichbarkeit au&szlig;erhalb der regul&auml;ren Arbeitszeit.</li>
									<li>Unklarheit: Fehlende Klarheit hinsichtlich der Aufgabenerf&uuml;llung und der eigenen Rolle.</li>
								</ul>
								<p>Die Facetten der Arbeitsdichte werden bei den Ergebnissen des Projekts n&auml;her beschrieben.</p>
							</v-card-text>
							<v-card-actions>
							<v-spacer></v-spacer>
								<v-btn color="primary" text @click="facettenDialog=false">Schlie&szlig;en</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
				</v-col>
				<v-col align-self="center">
					<v-autocomplete chips deletable-chips multiple :items="avKriterien" v-model="filterFacette"></v-autocomplete>
				</v-col>
			</v-row>
			<v-row no-gutters>
				<v-col align-self="center" class="spalte1">Freie Textsuche</v-col>
				<v-col align-self="center" class="spalte2">
					<v-dialog v-model="beschreibungDialog" persistent max-width="800">
						<template v-slot:activator="{ on, attrs }">
							<v-icon color="primary" v-bind="attrs" v-on="on">mdi-information</v-icon>
						</template>
						<v-card>
							<v-card-title class="headline">Freie Textsuche</v-card-title>
							<v-card-text>
								<p>&Uuml;ber diese Formularfeld k&ouml;nnen Sie &uuml;ber eine freie Textsuche nach Verfahren zur Arbeitsdichte suchen. Das Suchergebnis wird fortlaufend aktualisiert.</p>
							</v-card-text>
							<v-card-actions>
							<v-spacer></v-spacer>
								<v-btn color="primary" text @click="beschreibungDialog=false">Schließen</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
				</v-col>
				<v-col align-self="center">
					<v-text-field v-model="verfahrenSuchbegriff" @input="verfahrenSuchen(verfahrenSuchbegriff)"></v-text-field>
				</v-col>
			</v-row>
		</v-container>
		<v-container>			
			<v-row>
				<v-col cols="9">
					<h2>Ausgew&auml;hlte Verfahren ({{anzahlVerfahren}})</h2>
					<p>Die folgenden Liste enth&auml;lt alle Verfahren, die den oben gew&auml;hlten Filterkrierien entsprechen. Eine detaillierte Darstellung zu jedem Verfahren erhalten Sie, indem Sie auf &quot;Details&quot; klicken.</p>
				</v-col>
			</v-row>			
			<v-row>
				<v-col cols="4">
					<p>&nbsp;</p>
				</v-col>				
				<v-col self-justify="right">
					<v-container>
						<v-row no-gutters>
							<v-col align-self="center" class="spalte1">Sortieren</v-col>
							<v-col align-self="center" class="spalte2">
								<v-dialog v-model="sortierungDialog" persistent max-width="800">
									<template v-slot:activator="{ on, attrs }">
										<v-icon color="primary" v-bind="attrs" v-on="on">mdi-information</v-icon>
									</template>
									<v-card>
										<v-card-title class="headline">Sortierung</v-card-title>
										<v-card-text>
											<p>Sie k&ouml;nnen die Liste der Verfahren nach mehreren Kriterien sortieren. W&auml;hlen Sie zun&auml;chst ein Kriterium aus, nach dem Sie die Verfahren sortieren m&ouml;chten. Anschlie&szlig;end k&ouml;nnen Sie bestimmen, ob die Soriterung auf- oder absteigend erfolgen soll.</p>
										</v-card-text>
										<v-card-actions>
										<v-spacer></v-spacer>
											<v-btn color="primary" text @click="sortierungDialog=false">Schließen</v-btn>
										</v-card-actions>
									</v-card>
								</v-dialog>
							</v-col>
							<v-col justify-end>
								<v-spacer></v-spacer>
								<v-toolbar flat>
									<v-overflow-btn
										:items="sortierungKriterien"
										v-model="sortierungKriterium"
										label="Sortieren nach"
										hide-details
										dense
										class="pa-0"
										filled
									></v-overflow-btn>
									<v-btn-toggle v-model="sortierungReihenfolge" mandatory>
										<v-btn dense max-height="40" value="asc"><v-icon>mdi-sort-reverse-variant</v-icon></v-btn>
										<v-btn dense max-height="40" value="desc"><v-icon>mdi-sort-variant</v-icon></v-btn>
									</v-btn-toggle>
								</v-toolbar>
							</v-col>																
						</v-row>
					</v-container>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-card elevation="2" outlined shaped v-for="verfahr in orderedVerfahren" v-bind:key="verfahr.verfahrenid" v-model="orderedVerfahren" class="hinweis" style="margin-bottom:1em;" :class="{box1: verfahr.box1 == 1, box2: verfahr.box2 == 1}" @click="verfahrenAufrufen(verfahr.verfahrenid)">
						<v-card-title style="padding:0;">
							<v-container>			
								<v-row>
									<v-col cols="10">
										<p class="text-wrap">{{verfahr.titel}}</p>
										<p style="font-size:0.75em;font-weight:normal;">{{verfahr.autoren}} <span v-if="verfahr.jahr!=''">({{verfahr.jahr}})</span></p>
										<!-- {{verfahr.bewertung1}} / {{verfahr.bewertung2}} / {{verfahr.bewertung3}} / {{verfahr.bewertung4}} / {{verfahr.bewertung5}} -->
									</v-col>
									<!-- 
									<v-col>
										<small><star-rating v-if="verfahr.bewertung != null" v-bind:fixed-points="2" read-only v-bind:star-size="12" :rating="parseFloat(verfahr.bewertung.replace(',',','))" :round-start-rating="false"></star-rating></small>&nbsp;&nbsp;&nbsp;
										<span v-if="verfahr.beitraege != 0">
											<v-icon small color="amber">mdi-comment</v-icon>&nbsp;<small>{{verfahr.beitraege}}</small>
										</span>
									</v-col>	
									-->
									<!-- 
									<v-col>
										<modell
											kontext="verfahrensliste"
											v-bind:verfahrenid="verfahr.verfahrenid"
										></modell> 
									</v-col>
									-->
									<v-col align-self="end">
										<blume 
											kontext="verfahrensliste"
											v-bind:verfahrenid="verfahr.verfahrenid"
										></blume>
									</v-col>									
								</v-row>
							</v-container>
						</v-card-title>
					</v-card>
				</v-col>
			</v-row>
			<!--
			<v-row>
				<v-col>
					<v-dialog width="800" height="1200" v-model="verfahrenDialog">
						<template v-slot:activator="{ on, attrs }">
							<v-container>
								<v-btn color="primary" v-bind="attrs" v-on="on" v-if="teilnehmer!=''">Verfahren erstellen</v-btn>
							</v-container>
						</template>
						<v-card>
							<v-toolbar dark color="primary" dense>
								<v-toolbar-title>Verfahren</v-toolbar-title>
								<v-spacer></v-spacer>
								<v-btn icon dark @click="verfahrenDialog=false">
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</v-toolbar>
							<v-card-text>
								<v-form ref="form" lazy-validation>
									<h2>Facette der Arbeitsdichte</h2>
									<v-select
										v-model="verfahrenFacette"
										:items="avKriterien"
										:value="avKriterien.value"
										:label="avKriterien.text"
									></v-select>
									<h2>Titel des Verfahrens</h2>
									<v-text-field v-model="verfahrenTitel" label="Titel" required rows="1"></v-text-field>
									<h2>Beschreibung des Verfahrens</h2>
									<quill-editor 
										class="editor"
										ref="myTextEditor"
										v-model="verfahrenBeschreibung"
										:options="editorOption"
									>
									</quill-editor>
								</v-form>
							</v-card-text>
							<v-card-actions>
								<v-btn small color="primary" @click="verfahrenSpeichern()" :disabled="((verfahrenFacette == null) | (verfahrenTitel == '') | (verfahrenBeschreibung == '')) ? true : false">Verfahren einreichen</v-btn>
								<v-btn small color="primary" @click="verfahrenDialog=false">Schließen</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
				</v-col>
			</v-row>
			-->
		</v-container>
	</div>
</template>
<script>
	import axios from 'axios';
	import Fuse from 'fuse.js';
	import _ from 'lodash';
	// import StarRating from 'vue-star-rating'
	// import { quillEditor } from 'vue-quill-editor'
	// import 'quill/dist/quill.core.css'
	// import 'quill/dist/quill.snow.css'
	// import 'quill/dist/quill.bubble.css'	
	import blume from '../components/blume.vue';
	// import modell from '../components/modell.vue';
	export default {
		name: 'box',
		props: {
			lesezeichenListeAnzeigen: {
				type: Number
			},
			lesezeichenVerfahren: {
				type: Number
			}
		},
		components: {
			// StarRating,
			// quillEditor,
			// modell,
			blume
		},
		data: function () {
			return {
				statusDialog: false,
				boxenDialog: false,
				facettenDialog: false,
				sortierungDialog: false,
				beschreibungDialog: false,
				verfahrenDialog: false,
				verfahrenFacette: null,
				verfahrenTitel: '',
				verfahrenBeschreibung: '',
				editorOption: {
					modules: {
						toolbar: [
							[{ 'header': [3, 4, false] }],
							['bold', 'underline'],
							['blockquote'],
							[{ 'list': 'ordered' }, { 'list': 'bullet' }],
							['clean'],
							['link','image']
						]
					}
				},				
				verfahrenSuchfelder: [],
				verfahrenSuchbegriff: '',
				verfahren: null,
				verfahrenAuswahl: null,
				verfahrenDetails: {},
				sortierungReihenfolge: 'asc',
				sortierungKriterien: [
					{ value: 'titel', text: 'Titel' },
					{ value: 'autoren', text: 'Autoren' },
					{ value: 'jahr', text: 'Jahr' },
					{ value: 'bewertung1', text: 'Relevanz' },
					{ value: 'bewertung2', text: 'Evidenz' },
					{ value: 'bewertung3', text: 'Zugang' },
					{ value: 'bewertung4', text: 'Aufwand' },
					{ value: 'bewertung5', text: 'Hilfestellung' }								
				],
				sortierungKriterium: 'titel',
				statusKriterien: [
					{ value: 'status1', text: 'Verfahren eingereicht' },
					{ value: 'status2', text: 'Verfahren aufgenommen' },
					{ value: 'status3', text: 'Verfahren abgelehnt' }
				],
				boxKriterien: [
					{ value: 'box1', text: 'Analyse', color: "#f4f0e6"},
					{ value: 'box2', text: 'Maßnahme', color: "#d9d9f3"}
				],
				avKriterien: [
					{ value: 'av1', text: 'Menge' },
					{ value: 'av2', text: 'Unterbrechungen' },
					{ value: 'av3', text: 'Gleichzeitigkeit' },
					{ value: 'av4', text: 'Interdependenz' },
					{ value: 'av5', text: 'Arbeitsspitzen' },
					{ value: 'av6', text: 'Erweiterte Erreichbarkeit' },
					{ value: 'av7', text: 'Unklarheit' }
				],
				lesezeichenAnzeigen: 0,
				query: {},
				filterStatus: [],
				filterBox: [],
				filterFacette: [],
				freitextsuche: [],
				anzahlVerfahren: null
			}
		},
		methods: {
			verfahrenHolen: function(parameter) {
				axios.get('https://www.arbeitsverdichtung.de/api/verfahren', {
					params: parameter
				})
				.then(response => {
					this.verfahrenAuswahl = response.data;
					// console.log(this.verfahrenAuswahl);
					localStorage.setItem('verfahrenAuswahl', JSON.stringify(this.verfahrenAuswahl));
					this.anzahlVerfahren = this.verfahrenAuswahl.length;
				})
				.catch(error => {
					this.errorMessage = error.message;
					console.error("There was an error!", error);
				});
			},
			async verfahrenSuchfelderHolen() {
				try {
					const response = await axios.get('https://www.arbeitsverdichtung.de/api/verfahrenssuche');
					const data = await response;
					var verfahren = data.data;
					this.verfahrenSuchfelder = verfahren;
				} catch (error) {
					alert(error);
				}
			},
			async freitextAutosuche(suchbegriff) {
				await this.verfahrenSuchfelderHolen();
				this.verfahrenSuchen(suchbegriff);
			},
			async verfahrenSuchen(suchbegriff) {
				try {
					const options = {
						includeScore: true,
						includeMatches: true,
						threshold: 0.2,
						keys: ['titel', 'autoren', 'beschreibung']
					};
					const fuse = new Fuse(this.verfahrenSuchfelder, options);
					const result = fuse.search({
						$and: [
							{ $or: [
								{ titel: suchbegriff },
								{ autoren: suchbegriff },
								{ beschreibung: suchbegriff }
							]}
						]
					});
					this.freitextsuche = [];
					result.forEach(element => {
						this.freitextsuche.push(element['item']['verfahrenid']);
					});
				} catch (error) {
					alert(error);
				}
			},
			verfahrenAufrufen(verfahrenid) {
				// console.log('Verfahren aufrufen');
				this.$router.push({name: 'Verfahren', params: {verfahrenid: verfahrenid}});
			},
			verfahrenLesezeichen() {
				this.$store.dispatch('getLesezeichenListe');
			},
			// verfahrenSuchKriterien() {
			// 	this.$store.dispatch('getSuchKriterien');
			// },
			/* Zusammenstellung der Filterkriterien und Suchergebnisse für das Holen der Verfahren */
			queryErstellen() {
				this.query = {};
				if (this.filterStatus.length > 0) {
					for (var filter1 of this.filterStatus) {
						this.query[filter1] = 1;
					}
				}
				if (this.filterBox.length > 0) {
					for (var filter2 of this.filterBox) {
						this.query[filter2] = 1;
					}
				}
				if (this.filterFacette.length > 0) {
					for (var filter3 of this.filterFacette) {
						this.query[filter3] = 1;
					}
				}
				if (this.freitextsuche.length > 0) {
					this.query['verfahrenid'] = this.freitextsuche;
				}
				if (this.lesezeichenListe != '') {
					if (this.lesezeichenAnzeigen == 1) {
						this.query['verfahrenid'] = this.lesezeichenListe;
					}
				}
				this.verfahrenHolen(this.query);
			},
			// filteredVerfahren: function() {
			// 	// this.verfahren = _.filter(localStorage.getItem('verfahren'), this.query);
			// 	console.log(this.verfahrenAuswahl);
			// 	this.anzahlVerfahren = this.verfahrenAuswahl.length;
			// },
			/* Verfahren speichern */
			verfahrenSpeichern: function() {
				axios.post('https://www.arbeitsverdichtung.de/api/verfahren', {
					teilnehmer: this.teilnehmer,
					facette: this.verfahrenFacette,
					titel: this.verfahrenTitel,
					beschreibung: this.verfahrenBeschreibung
				})
				.then(response => {
					console.log(response);
					this.verfahrenFacette = null;
					this.verfahrenTitel = '';
					this.verfahrenBeschreibung = '';
					this.verfahrenDialog = false;
					this.verfahrenHolen(this.query);
				})
				.catch(error => {
					console.log(error);
				});
			},
			removeBoxkriterium: function(item) {
				const index = this.filterBox.indexOf(item)
				if (index >= 0) this.filterBox.splice(index, 1)
			}
		},
		created() {
			this.verfahrenSuchfelderHolen();
		},
		mounted() {
			// Vorauswahl und alle Verfahren holen
			this.filterStatus.push('status2');
			this.filterBox.push('box1');
			this.filterBox.push('box2');	
			this.filterFacette.push('av1');
			this.filterFacette.push('av2');
			this.filterFacette.push('av3');
			this.filterFacette.push('av4');
			this.filterFacette.push('av5');
			this.filterFacette.push('av6');
			this.filterFacette.push('av7');
			// Die gespeicherte Suche wird aufgerufen
			if (this.$store.state.suchKriterien.filterBox.length > 0 ) this.filterBox = this.$store.state.suchKriterien.filterBox;
			if (this.$store.state.suchKriterien.filterFacette.length > 0 ) this.filterFacette = this.$store.state.suchKriterien.filterFacette;
			if (this.$store.state.suchKriterien.verfahrenSuchbegriff != '' ) this.verfahrenSuchbegriff = this.$store.state.suchKriterien.verfahrenSuchbegriff;
			if (this.$store.state.suchKriterien.sortierungKriterium != '' ) this.sortierungKriterium = this.$store.state.suchKriterien.sortierungKriterium;
			if (this.$store.state.suchKriterien.sortierungReihenfolge != '' ) this.sortierungReihenfolge = this.$store.state.suchKriterien.sortierungReihenfolge;
			// Falls ein Filter übergeben wurde
			// console.log(this.$route.query.filter);	
			// if (this.$route.query.filter != '') {
			// 	this.filterFacette.splice(0);
			// 	this.filterFacette.push(this.$route.query.filter);
			// } 
			// Nach dem Aufbau der Seiten werden etwaige übergebene Parameter in lokale Variablen übernommen
			// if (this.lesezeichenListeAnzeigen == 1) {
			// 	this.lesezeichenAnzeigen = this.lesezeichenListeAnzeigen;
			// }
			// if (this.lesezeichenVerfahren ) {
			// 	console.log(this.$refs);
			// 	console.log(this.lesezeichenVerfahren);
			// 	var lesezeichenVerfahren = String(this.lesezeichenVerfahren);
			// 	console.log(lesezeichenVerfahren);
			// 	this.$refs.lesezeichenVerfahren.click();
			// }
		},
		watch: {
			// Bei einer Änderung von Filter, Freitext oder Lesezeichen wird die Query nochmals ausgeführt. Dies erfolgt durch Eingabe oder programmatische Veränderung
			filterStatus: function() {
				this.queryErstellen();
			},
			filterBox: function() {
				this.queryErstellen();
			},
			filterFacette: function() {
				this.queryErstellen();
			},
			verfahrenSuchbegriff: function () {
				this.freitextAutosuche(this.verfahrenSuchbegriff);
			},
			freitextsuche: function () {
				this.queryErstellen();
			},
			lesezeichenListe: function () {
				this.queryErstellen();
			},
			lesezeichenAnzeigen: function () {
				this.queryErstellen();
			},
			filterUebergabe: function () {
				alert(this.filterUebergabe);
				this.filterBox = this.filterUebergabe;
				this.queryErstellen();
			}
		},
		computed: {
			teilnehmer: function() {
				return this.$store.state.teilnehmer;
			},
			lesezeichenListe: function() {
				return this.$store.state.lesezeichenListe;
			},
			filterSuchKriterien: function() {
				return this.$store.state.SuchKriterien;
			},			
			orderedVerfahren: function() {
				return _.orderBy(this.verfahrenAuswahl, _.toLower([this.sortierungKriterium]), [this.sortierungReihenfolge]);
			}
		},
		beforeDestroy() {
			// Beim verlassen der Seite wird die Suche gespeichert
			this.$store.dispatch('setSuchKriterien', {
				lesezeichenAnzeigen: this.lesezeichenAnzeigen,
				filterStatus: this.filterStatus,
				filterBox: this.filterBox,
				filterFacette: this.filterFacette,
				verfahrenSuchbegriff: this.verfahrenSuchbegriff,
				sortierungKriterium: this.sortierungKriterium,
				sortierungReihenfolge: this.sortierungReihenfolge
			});
		}
	}
</script>
<style scoped>
	.spalte1 {
		max-width: 7em;
		min-width: 7em;
		font-weight: bold;
	}
	.spalte2 {
		max-width: 3em;
	}
	#sortierungFeld {
		width: 12em;
		float: right;
	}
	.box1 {
		border-left-style: solid;
		border-left-width: 2em;
		border-left-color: #a3660533;
	}
	.box2 {
		border-left-style: solid;
		border-left-width: 2em;
		border-left-color: #0c366b33;
	}
	.v-text-field__details {
		display: none;
		max-height: 0px;
		min-height: 0px;
	}
	.v-text-field .v-text-field--enclosed .v-text-field__details {
		margin-bottom: 0px;
	}
	.v-card__title, .v-card__text {
		word-break: normal; 
	}
</style>
